import React from 'react'
import clsx from 'clsx'
import { EMkLoadingType } from '@typescript'
import { Loading, LoadingProps } from '@components/ui/Loading/Loading'

export interface MkAuthLoadingScreenProps extends LoadingProps {
  imgSrc?: string
  imgAlt?: string
  heading?: string
  subheading?: string
  show?: boolean
}

export const MkAuthLoadingScreen: React.FC<MkAuthLoadingScreenProps> = ({ imgSrc, imgAlt, heading, subheading, show }) => (
  <div className={clsx('fixed inset-0 z-50 flex items-center justify-center', { hidden: !show })}>
    <Loading
      type={EMkLoadingType.PAGE}
      imgSrc={imgSrc}
      imgAlt={imgAlt}
      heading={heading}
      subheading={subheading}
    />
  </div>
)
